import React from 'react';
import { maskPhoneNumber, maskAadhaarNumber } from '../utils/maskingUtils';

const MaskedDisplay = ({ type, value, className }) => {
  if (!value) return null;
  
  const maskedValue = type === 'phone' ? maskPhoneNumber(value) : maskAadhaarNumber(value);
  
  return (
    <span className={className}>
      {maskedValue}
    </span>
  );
};

export default MaskedDisplay;